import { Fragment } from 'react';
import { always } from 'ramda';
import { isFunction } from 'ramda-extension';
import cc from 'classcat';

import Button from '../Button';
import Loading from '../Loading';

import styles from './styles.module.scss';

export const UpcomingGameButton = ({
  label,
  game,
  children = always(undefined),
  to,
  handleClick,
  navigating,
  className,
  ...buttonProps
}) => (
  <Fragment>
    <Button
      {...buttonProps}
      to={to}
      onClick={handleClick}
      className={cc([styles.button, className])}
    >
      <span className={styles.label}>{label}</span>
      {navigating && <Loading className={styles.loading} />}
    </Button>
    {isFunction(children) ? children(game) : children}
  </Fragment>
);
